export default __webpack_public_path__ + "static/media/connect-default.229076fe.png";